import * as React from 'react'
import { CountryCode } from '@doordash/lib-i18n'
import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { DX_CRO_LP_GRADUATION_Q3_2020 } from '../../../experimentConstants'
import { HeroImageWithURLV2 } from './styles'
import {
  AWS_BASE,
  BASE_GROWTH_IMAGE_CDN,
  CLOUDFLARE_DEFAULT_BASE,
  COUNTRY_SHORTCODES,
} from '../../../constants'

const CA_IMG = `${AWS_BASE}/img/dasher/payout.png`
const JP_IMG = `${AWS_BASE}/img/dasher/payout-bicycle.png`
const US_IMG = `${BASE_GROWTH_IMAGE_CDN}/landing-page/dasher-illustration.png`
const AU_IMG = `${BASE_GROWTH_IMAGE_CDN}/landing-page/dasher-aus.png`
const NZ_IMG = `${BASE_GROWTH_IMAGE_CDN}/landing-page/dasher-nz.png`
const DEFAULT_IMG = `${CLOUDFLARE_DEFAULT_BASE}/${AWS_BASE}/img/dasher/landingpage_hero_desktop_nowave.jpg`

type SignupImageParams = {
  country: CountryCode
}

const getImageForCountry = country => {
  switch (country) {
    case COUNTRY_SHORTCODES.US:
      return US_IMG
    case COUNTRY_SHORTCODES.AU:
      return AU_IMG
    case COUNTRY_SHORTCODES.CA:
      return CA_IMG
    case COUNTRY_SHORTCODES.NZ:
      return NZ_IMG
    default:
      return DEFAULT_IMG
  }
}

const getImageURL = country => {
  if (country === COUNTRY_SHORTCODES.JP) return JP_IMG
  if (isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020))
    return getImageForCountry(country)
  return DEFAULT_IMG
}

export const SignupImage = React.memo(({ country }: SignupImageParams) => {
  const url = getImageURL(country)
  return (
    <HeroImageWithURLV2
      url={url}
      country={country}
      isQ3CroGraduation={isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020)}
    />
  )
})

export default SignupImage
